import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsArchicadComponent } from './simple-icons-archicad.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsArchicadComponent ],
    exports:      [ SimpleIconsArchicadComponent ],
    bootstrap:    []
})
export class SimpleIconsArchicadModule {}
